/**
 * Interop class for device-related functionalities in Blazor applications.
 */
export class DeviceInterop {
    /**
     * Checks if the device is mobile.
     */
    public isMobileDevice(): boolean {
        return globalThis.matchMedia('(max-width:768px)').matches;
    }

    /**
     * Registers a callback for device type changes.
     */
    public registerDeviceTypeChanged(dotNetRef: any): void {
        const notify = () => {
            dotNetRef.invokeMethodAsync('OnDeviceTypeChanged', this.isMobileDevice());
        };
        globalThis.addEventListener('resize', notify);
        // Initial call
        notify();
        // Store for cleanup
        (globalThis as any)._deviceTypeChangedNotify = notify;
    }

    /**
     * Unregisters the device type change callback.
     */
    public unregisterDeviceTypeChanged(): void {
        if ((globalThis as any)._deviceTypeChangedNotify) {
            globalThis.removeEventListener('resize', (globalThis as any)._deviceTypeChangedNotify);
            (globalThis as any)._deviceTypeChangedNotify = null;
        }
    }
}

/**
 * Interop instance for device-related functionalities.
 */
(globalThis as any)['DeviceInterop'] = new DeviceInterop();
